import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./index.scss";
import { useEffect, useState } from "react";
import useInputKeys from "hooks/useInputKeys";

function SliderComponentTitle({
  styleSwiper,
  styleSwiperSlide,
  data,
  defaultSlide = 0,
  maxWidth,
  maxFont,
  additionalCssClass,
  onSlideAction = () => {},
  slideReverseAction = () => {},
  onActiveSlideChange = () => {},
  onClickSlide = () => {},
}) {
  const {
    setActiveSlideArtistName
  } = useInputKeys();
  const [swiperState, setSwiperState] = useState(null);
  const [activeSlide, setActiveSlide] = useState(defaultSlide);
  useEffect(() => {
    if (swiperState) {
      swiperState.slideTo(defaultSlide);
    }
  }, [swiperState, defaultSlide]);

  useEffect(()=>{
    onActiveSlideChange(data[activeSlide]?.actionValue);
  }, [activeSlide, onActiveSlideChange, data]);

  const handleTouchEnd = (event) => {
    let dx = event.touches.currentX - event.touches.startX;
    let dy = event.touches.currentY - event.touches.startY;
    if (dy < -5 && Math.abs(dx) < Math.abs(dy)) {
      let item = data[activeSlide];
      onSlideAction(item.actionValue);
    }
    if (dy > 5 && Math.abs(dx) < Math.abs(dy)) {
      slideReverseAction(0);
    }
  };
  const handleClick = (event) => {
    let dx = event.touches.currentX - event.touches.startX;
    let dy = event.touches.currentY - event.touches.startY;
    let item = data[activeSlide];
    if (Math.abs(dy) < 2 && Math.abs(dx) < 2) {
      onSlideAction(item.actionValue);
    } else {
      slideReverseAction(0);
    }
    
  };

  const fontSizeSwiper = (item) => {
    if (window.screen.width >= 1100) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 23);
    }
    if (window.screen.width >= 768) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 21);
    }
    if (window.screen.width >= 480) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 20);
    }
    if (window.screen.width < 480) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 15);
    }
    if (window.screen.width < 384) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 12);
    }
  };

  return (
    <>
      <Swiper
        className="patent-swiper"
        style={styleSwiper}
        onSwiper={setSwiperState}
        spaceBetween={0}
        slidesPerView={"auto"}
        centeredSlides={true}
        onActiveIndexChange={(index) => {
          setActiveSlide(index.activeIndex);
          setActiveSlideArtistName(index.activeIndex)
        }}
        onTouchEnd={handleTouchEnd}
        onClick={handleClick}
      >
        {data?.map((item, index) => (
          <SwiperSlide
            key={index}
            className={`swiperSlider ${additionalCssClass} ${
              index === activeSlide ? "active" : "notActive"
            }`}
            style={{
              ...styleSwiperSlide,
              fontSize: `${fontSizeSwiper(item)}px`,
            }}
          >
            {item.text}
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default SliderComponentTitle;